import { apiClient } from '@/shared/lib/axios';
import { Insurer } from '@/types/admin-insurer';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
type Response<T> = {
  data: T;
};
const getInsurerDetail = async (
  siteType: string | null,
  id: string
): Promise<Response<Insurer>> => {
  const response = await apiClient.get<Response<Insurer>>(`/admin/${siteType}/insurers/${id}`);
  return response.data;
};

export const useGetInsurerDetail = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';

  return useQuery({
    queryKey: ['admin-insurer-detail', currentSite, id],
    queryFn: () => getInsurerDetail(currentSite, id as string),
    enabled: !!id,
    select: res => res.data,
  });
};
